<template>
  <div class="ma-0 d-flex seleccion-material align-content-start flex-wrap" style="max-width: 100%">

    <v-col v-show="cargando" cols="3" v-for="i in 2" :key="'sk' + i">
      <v-skeleton-loader type="image"/>
    </v-col>

    <div :style="widthCss" class="pa-0 ma-0" v-show="!cargando" v-for="(mat, clave, index) in materiales"
         :key="`${clave} ${index}`">
      <v-card class="contenido-card ma-1">
        <v-menu :nudge-width="200" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn fab dark small class="boton mano" color="primary" v-on="on" depressed>
              <v-icon>mdi-folder</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list max-height="300px" class="pa-0 overflow-y-auto">
              <v-list-item @click="abrirBiblioteca(mat)">
                {{ $t('abrir_pers', [mat.nombre]) }}
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-card class="mano pa-0 ma-0" min-height="224px"
                :class="{'secondary': materialSeleccionado && mat.codigo === materialSeleccionado.codigo}"
                @click="seleccionarMaterial(mat)">
          <v-card-title class="text-center body-1 primary--text">
            {{ mat.nombre }}
          </v-card-title>
          <v-card-text class="pa-1">
            <v-img :src="calcularMaterialImgSrc(mat)" contain max-width="180px">
              <template v-slot:placeholder>
                <v-skeleton-loader type="image" min-width="180px" max-width="180px" min-height="160px"
                                   max-height="160px"/>
              </template>
            </v-img>
          </v-card-text>
        </v-card>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import ImagenesServicio from "../../../../comunes/servicios/ImagenesServicio";
import {mapState} from 'vuex';

export default {
  name: "SelectorMaterial",
  components: {},
  props: {
    tipSolCons: {type: Object, required: true},
    ceramicos: {type: Boolean, default: true},
    width: {type: String, default: "200"},
  },
  data: () => ({
    materialSeleccionado: null,
    cargando: false,
    materiales: [],
    menuPers: false,
  }),
  computed: {
    ...mapState(["usuario"]),
    urlMateriales() {
      if (!this.tipSolCons) return null;
      let no = !this.ceramicos ? "no-" : "";
      return `materiales/${this.tipSolCons.codigo}/${no}ceramicos`;
    },
    widthCss() {
      return {
        'min-width': this.width + 'px',
        'max-width': this.width + 'px'
      }
    }
  },
  watch: {
    tipSolCons: function () {
      this.obtenerMateriales();
    },
    ceramicos: function () {
      this.obtenerMateriales();
    },
    materialSeleccionado: function () {
      this.emitirChange();
    }
  },
  mounted: function () {
    this.obtenerMateriales();
  },
  methods: {
    emitirChange() {
      if (this.materialSeleccionado == null) this.$emit("change", null, null);
      else this.$emit("change", "material", this.materialSeleccionado);
    },
    calcularMaterialImgSrc(material) {
      return ImagenesServicio.imgMaterial(this.tipSolCons.codigo, material.referencia);
    },
    seleccionarMaterial(material) {
      this.materialSeleccionado = material;
    },
    obtenerMateriales() {
      this.materiales = [];
      if (this.urlMateriales == null) return;
      this.cargando = true;
      HttpHelper.get(this.urlMateriales)
          .then((materiales) => {
            this.materiales = materiales;
          })
          .finally(() => {
            this.cargando = false;
          });
    },
    abrirBiblioteca(material) {
      this.$emit("biblioteca-click", material);
    }
  },
}
</script>

<style scoped lang="scss">
.contenido-card {
  box-shadow: none !important;
  position: relative;
  cursor: pointer;
  border: 2px solid #40108e !important;
}

.boton {
  position: absolute;
  bottom: 5%;
  right: 5%;
  z-index: 1
}

.mano {
  cursor: url('../../../../assets/iconos/cursor.png'), auto !important;
}

.seleccion-material {
  .v-card__title {
    padding: 8px 8px 16px;
    word-break: keep-all;

  }
}

.v-application.sm-down {
  .seleccion-material {
    .col-3 {
      max-width: 50% !important;
    }
  }
}
</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "abrir_pers": "Pulsa para abrir la biblioteca de materiales y evaluar un material personalizado de {0}."
  }
}
</i18n>
<!--@formatter:on-->